// JS file for EventItem

$('.c-event').find('iframe, object, embed').parent().addClass('rwd-video');
